<template>
  <v-expansion-panel class="schema-field-panel">
    <v-expansion-panel-header :class="{ 'error--text': hasError }">
      <div class="d-flex align-center" style="width: 100%">
        <v-icon small class="mr-2 drag-handle" @click.stop>mdi-drag-vertical</v-icon>
        <template v-if="field.type === 'fragment'">
          <v-chip x-small outlined class="mr-2">fragment</v-chip>
          <span v-if="field.$ref" class="font-weight-medium mr-2">{{ field.$ref }}</span>
          <span v-else class="grey--text mr-2">(no fragment selected)</span>
        </template>
        <template v-else>
          <span class="font-weight-medium mr-2">{{ field.key || '(no key)' }}</span>
          <span v-if="field.label" class="grey--text mr-2">— {{ field.label }}</span>
          <v-chip x-small outlined class="mr-2">{{ field.type || '?' }}</v-chip>
          <v-chip v-if="field.indexed" x-small color="blue" dark class="mr-1">idx</v-chip>
          <v-chip v-if="field.translatable" x-small color="green" dark class="mr-1">i18n</v-chip>
          <v-chip v-if="field.$ref" x-small color="purple lighten-4" class="mr-1">$ref: {{ field.$ref }}</v-chip>
          <v-chip v-if="field.fieldset" x-small outlined color="purple" class="mr-1">{{ field.fieldset }}</v-chip>
        </template>
        <v-spacer />
        <div class="panel-actions" @click.stop>
          <v-btn icon x-small :disabled="isFirst" @click="$emit('move-up')">
            <v-icon x-small>mdi-arrow-up</v-icon>
          </v-btn>
          <v-btn icon x-small :disabled="isLast" @click="$emit('move-down')">
            <v-icon x-small>mdi-arrow-down</v-icon>
          </v-btn>
          <v-btn icon x-small @click="$emit('duplicate')">
            <v-icon x-small>mdi-content-copy</v-icon>
          </v-btn>
          <v-btn icon x-small color="error" @click="$emit('remove')">
            <v-icon x-small>mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <schema-field-settings
        :field="field"
        :sibling-fields="siblingFields"
        :fieldset-options="fieldsetOptions"
        :cms-types="cmsTypes"
        :fragment-types="fragmentTypes"
        :is-top-level="isTopLevel"
        @update="$emit('update', $event)"
        @edit-nested="$emit('edit-nested')"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import SchemaFieldSettings from './SchemaFieldSettings'

export default {
  components: {
    SchemaFieldSettings,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    siblingFields: {
      type: Array,
      default: () => [],
    },
    fieldsetOptions: {
      type: Array,
      default: () => [],
    },
    cmsTypes: {
      type: Array,
      default: () => [],
    },
    fragmentTypes: {
      type: Array,
      default: () => [],
    },
    isTopLevel: {
      type: Boolean,
      default: true,
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasError() {
      return !this.field.key || !this.field.label || !this.field.type
    },
  },
}
</script>

<style scoped>
.schema-field-panel .drag-handle {
  cursor: grab;
}
.panel-actions {
  display: flex;
  gap: 2px;
}
.panel-actions .v-btn {
  cursor: pointer;
}
.schema-field-panel .v-expansion-panel-header {
  cursor: pointer;
}
</style>
